<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" scrollable
                   :title="computedTitle" @show="onShow" hide-footer body-class=""
                   @hidden="onHidden" :show-confirmation="showConfirmation"
                   :is-loading="loading" modal-class="mobile-full-screen">
      <div v-if="loading">
        <spinner show height="10"/>
      </div>
      <div v-else-if="lot && lot.reservation">
        <div class="row">
          <div class="col-md-12">
            <reservation-info-table :reservation="lot.reservation" v-if="lot && lot.reservation" show-thumbnail
                                    show-description/>
          </div>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import LotsService from "@/modules/lots/LotsService";
  import Spinner from "@/core/components/common/Spinner";
  import ReservationInfoTable from "@/modules/reservations/view/dashboard/ReservationInfoTable";

  const {mapActions, mapState} = createNamespacedHelpers('lots');

  export default {
    name: "LotInfoModal",
    components: {
      ReservationInfoTable,
      Spinner,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: false,
        lot: null
      }
    },
    computed: {
      ...mapState({
        modal: state => state.lotInfoModal,
      }),
      computedTitle() {
        return this.$i18n.t('Lot Info')
      }
    },
    methods: {
      ...mapActions(['hideLotInfoModal']),
      onHidden() {
        this.lot = null
        this.hideLotInfoModal()
      },
      async onShow() {
        if (!this.modal.lot_uuid) {
          setTimeout(() => {
            this.$errorDialog(this.$i18n.t('Could not retrieve lot information. Please, try again later.'))
            this.hideLotInfoModal()
            return true
          }, 500)
          return true
        }

        this.loading = true
        let response = await LotsService.getLot(this.modal.lot_uuid, [
          'reservation.inventory.source_inventories_count',
          'reservation.inventory.grouped_inventories_count',
          'reservation.inventory.receipt',
          'reservation.inventory.images',
          'reservation.inventory.category',
          'reservation.inventory.department',
          'reservation.inventory.item_location',
          'reservation.inventory.customer.billing_address',
          'reservation.inventory.branch',
          'reservation.inventory.specialists',
          'reservation.auction',
          'reservation.lot.financial_item',
        ].join(','))
        this.loading = false

        if (!response.success) {
          this.$errorDialog(this.$i18n.t('Could not retrieve lot information. Please, try again later.'))
          this.hideLotInfoModal()
          return true
        }

        this.lot = response.body
      },
    }
  }
</script>

<style scoped>

</style>
